"use client"

const PatientModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h2 className="text-xl font-bold text-charcoal-800 mb-4">Patients – Product Support</h2>
        <p className="text-charcoal-700 mb-6">
          Patients with a current Mediwhistle prescription can contact us by emailing{" "}
          <a href="mailto:admin@mediwhistle.com.au" className="text-emerald-800 hover:text-emerald-700 underline">
            admin@mediwhistle.com.au
          </a>
          .
        </p>
        <button
          onClick={onClose}
          className="w-full bg-emerald-800 hover:bg-emerald-700 text-white py-2 px-4 rounded-md font-medium transition-colors"
        >
          Close
        </button>
      </div>
    </div>
  )
}

export default PatientModal
